import disasters from '@/data/disasters'
import facilities from '@/data/facilities'

export default [
  ...disasters.map(i => ({
    ...i,
    type: 'DISASTER'
  })),
  ...facilities.map(i => ({
    ...i,
    type: 'FACILITY'
  }))
]